import type { QueryClient } from '@tanstack/react-query';

import type { AppShellApiClient, SubscriptionResponse } from '../shared/types';
import createQueryConfig, { NotFoundError } from '../queries';

export async function fetchSubscription(
  merchantId: string,
  apiClient: AppShellApiClient,
  queryClient: QueryClient
): Promise<SubscriptionResponse | null> {
  try {
    const queryConfig = createQueryConfig(queryClient, apiClient);
    const { queryKey, queryFn } = queryConfig.subscription({ merchantId });

    return await queryClient.fetchQuery<SubscriptionResponse>({
      queryKey,
      queryFn,
    });
  } catch (error) {
    if (error instanceof NotFoundError) {
      return null;
    }

    throw error;
  }
}
